<br/>
<div class="container mx-auto">
  <div class=" ">
    <h2>Schedules</h2>
    <app-system-wide-message></app-system-wide-message>
  </div>
  <ng-container *ngIf="recent_routes.length > 0">
    <div class="row p-2">
      <div>
        <h2>Recently Visited</h2>
      </div>
    </div>
  </ng-container>
  <div class="row p-0 m-0" *ngFor="let recent_route of recent_routes; index as i;">
    <ng-container *ngFor="let route of all_routes" >
      <div class="col p-1 route-selectable" *ngIf="route.id == recent_route">
        <a routerLink="/schedules/{{route.id}}">
          <button class="btn btn-outline-dark  w-100 h-100" type="submit" (click)="selectRoute(route.id)">{{ route.name }}

            <div class="route-selection-status">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                  *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                  *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </a>
      </div> 
    </ng-container>
  </div>

  <div class="row p-2">
    <h2>Subway &amp; Trolley</h2>
  </div>
  <div class="row p-0 m-0" *ngFor="let routes of statuses['others']; index as i">
    <div class="col p-1 route-selectable" *ngFor="let route of routes">
        <a routerLink="/schedules/{{route.id}}">
          <button class="btn btn-outline-dark  w-100 h-100" type="submit" (click)="selectRoute(route.id)">{{ route.name }}

            <div class="route-selection-status">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                  *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                  *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </a>
      </div> 
  </div>
  <div class="row p-0 m-0" *ngFor="let routes of statuses['trolley']; index as i">
    <div class="col p-1 route-selectable" *ngFor="let route of routes">
        <a routerLink="/schedules/{{route.id}}">
          <button class="btn btn-outline-dark  w-100 h-100" type="submit" (click)="selectRoute(route.id)">{{ route.name }}

            <div class="route-selection-status">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                  *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                  *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </a>
      </div>
      
  </div>
  <div class="row p-2">
    <h2>Regional Rail</h2>
  </div>
  <div class="row p-0 m-0" *ngFor="let routes of statuses['rail']; index as i">
    <div class="col p-1 route-selectable" *ngFor="let route of routes">
        <a routerLink="/schedules/{{route.id}}">
          <button class="btn btn-outline-dark  w-100 h-100" type="submit" (click)="selectRoute(route.id)">{{ route.name }}

            <div class="route-selection-status">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                  *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                  *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </a>
      </div>
  </div>
  <div class="row p-2">
    <h2>Bus</h2>
  </div>
  <div>
    <div class="row p-0 m-0" *ngFor="let routes of statuses['bus']; index as i">
      <div class="col p-1 route-selectable" *ngFor="let route of routes">
        <a routerLink="/schedules/{{route.id}}">
          <button class="btn btn-outline-dark  w-100 h-100" type="submit" (click)="selectRoute(route.id)">{{ route.name }}

            <div class="route-selection-status">
              <span [ngClass]="{'icon-inactive': route.isalert === false}">
                <img class="status-icons" src="../../../assets/images/route-status/alert.png"
                  *ngIf="route.issuspended == false">
                <img class="status-icons" src="../../../assets/images/route-status/suspended.png"
                  *ngIf="route.issuspended == true">
              </span>
              <span [ngClass]="{'icon-inactive': route.isadvisory === false}">
                <img class="status-icons" src="../../../assets/images/route-status/advisory.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == true">
                <img class="status-icons" src="../../../assets/images/route-status/weather-icon.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.isdetour === false}" *ngIf="route.isweather == false">
                <img class="status-icons" src="../../../assets/images/route-status/detour.png">
              </span>
              <span [ngClass]="{'icon-inactive': route.iselevator === false}">
                <img class="status-icons" src="../../../assets/images/route-status/elevator.gif">
              </span>
            </div>
          </button>
        </a>
      </div>
    </div>
  </div>
</div>

<app-main-footer></app-main-footer>